

export const format_si_number = (n) => {
    if (n < 10000) {return n;}
    
    var nn = n.toExponential(2).split(/e/);
      var u = Math.floor(+nn[1] / 3);
      return nn[0] * Math.pow(10, +nn[1] - u * 3) + ['p', 'n', 'u', 'm', '', 'k', 'M', 'G', 'T'][u+4];
}
  